// One raw events-API payload (expand=[event_bookings, private_lessons]) into
// the display slot shape availability-slot-row renders. Returns null when the
// event has no coach booking (or none for the requested coach). Callers decide
// whether cancelled/declined slots stay in the list — the coach agenda shows
// them, the command center drops them.
export function slotFromEvent(event, { coachId = null } = {}) {
  const bookings = event.event_bookings || [];
  const coachBooking = bookings.find((b) => b.profile_type === 'CoachProfile' && (coachId === null || b.profile_id === coachId));
  if (!coachBooking) {
    return null;
  }

  const wrestlerBookings = bookings.filter((b) => b.profile_type === 'WrestlerProfile' && ['confirmed', 'completed', 'invited', 'pending'].includes(b.status));

  return {
    id: event.id,
    coachId: coachBooking.profile_id,
    // Booking profiles serialize display_name (full name), not first/last
    coachName: coachBooking.profile ? coachBooking.profile.display_name : 'Coach',
    startAt: moment(event.start_at),
    endAt: moment(event.end_at),
    status: coachBooking.status,
    coachBookingId: coachBooking.id,
    privateLessonId: (event.private_lessons && event.private_lessons[0]) ? event.private_lessons[0].id : null,
    // Set only for structured locations, where `location` is the
    // machine-built "Venue Name — address" string
    locationId: event.location_id,
    location: event.location,
    recurring: event.has_repeated_events || event.parent_id != null,
    rosterNames: (event.roster_events || []).map((re) => re.roster.name),
    wrestlers: wrestlerBookings.map((b) => ({
      name: b.profile ? b.profile.display_name : 'Unknown',
      status: b.status,
    })),
    confirmedCount: wrestlerBookings.filter((b) => b.status === 'confirmed' || b.status === 'completed').length,
    billingPlan: wrestlerBookings.length > 0 ? wrestlerBookings[0].billing_plan : null,
  };
}
